export default {"src":"/_next/static/image/public/images/ic_upload_pdf.e8d920673653db0f54254ce66811b254.svg","height":32,"width":26};